
const ContentImage = ({ title, img_uri_lowRes: pathLowRes }) => (
    <img src={pathLowRes} className="img-fluid" alt={title} />
);

export default ContentImage;